import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { RevShareApiClient } from '../../api-clients';
const {
  Provider,
  context,
  ...client
} = RevShareApiClient;
export const RevShareExtension = createModuleExtension({
  extensionName: 'revShareExtension',
  Provider,
  SDK: {
    revShareApiClient: client,
    revShareContext: context
  }
});
//# sourceMappingURL=rev-share.extension.js.map